// YYYY-MM-DD
export const formatDateToUTC = (dateStr) => {
	const date = new Date(dateStr);
	return `${date.getDate().toString().padStart(2, "0")}.${(date.getMonth() + 1)
		.toString()
		.padStart(2, "0")}.${date.getFullYear()}`;
};

// DD.MM.YYYY HH:MM
export const formatDateAndTimeToUTC = (dateString: string): string => {
	const date = new Date(dateString.replace(" ", "T"));
	const options: Intl.DateTimeFormatOptions = {
		day: "2-digit",
		month: "2-digit",
		year: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		timeZone: "Europe/Moscow",
		hour12: false,
	};

	return new Intl.DateTimeFormat("ru-RU", options).format(date) + " по МСК";
};
